import { GridToolbarFilterButtonProps } from "@mui/x-data-grid-pro";
import { GridToolbarFilterButton7 } from "../../platform-style";
import { forwardRef } from "react";

interface GridToolbarFilterButtonLegacyProps extends GridToolbarFilterButtonProps {
  componentsProps?: any;
}

/**
 * @deprecated Use GridToolbarFilterButton7 instead.
 */
export const GridToolbarFilterButton = forwardRef(function (
  props: GridToolbarFilterButtonLegacyProps,
  ref
) {
  props.componentsProps["button"]["variant"] = "text";
  // @ts-ignore
  return <GridToolbarFilterButton7 {...props} slotProps={props.componentsProps} ref={ref} />;
});
